import React from 'react';
const chips = ['No forms to fill', 'Refunded to your original payment method', 'Keep the bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="arcs-dark w-full bg-night" data-id="element-143" data-mp="1o5q1qgnuw7zz">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center sm:py-20" data-id="element-144" data-mp="221bvt28y5hz9">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-[3px] border-dashed border-coral text-coral" data-id="element-145" data-mp="1x4uxjf819n8g">
          <span className="font-display text-4xl leading-none" data-id="element-146" data-mp="14fxu2i8hduzr">7</span>
          <span className="text-xs font-bold uppercase tracking-widest" data-id="element-147" data-mp="14dl4pk0e8ico">Days</span>
        </div>
        <p className="eyebrow mt-6 text-saffron" data-id="element-148" data-mp="1j6n8dth8nq7u">Zero risk</p>
        <h2 id="guarantee-heading" className="lane-underline mt-3 font-display text-[30px] leading-tight text-sand sm:text-5xl" data-id="element-149" data-mp="1ecsnimpwd576">
          Open everything. Teach a class from it.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-sand/80" data-id="element-150" data-mp="lowk6z5tof1f">
          Read the volumes, print a session, teach it to your room. If Acro
          Yoga Class Ready doesn&apos;t change how you plan and run class,
          email us within 7 days and you get every cent back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-151" data-mp="ypurj4wvbace">
          {chips.map(chip => <li key={chip} className="rounded-full border border-sand/25 px-4 py-2 text-[13px] text-sand/80" data-id="element-152" data-mp="12q4xihknu0r9">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}